import React from 'react';

export { BatteryIndicatorVertical };

function BatteryIndicatorVertical({ percentage, index }) {
    // Limite le pourcentage entre 0 et 100
    const clampedPercentage = Math.min(Math.max(percentage, 0), 100);
    const value = clampedPercentage !== 0  ? `${clampedPercentage}%` : 'N/A';

    return (
        <div style={{ textAlign: 'center' }}>
            <svg
                id="Calque_1"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                style={{ width: 'auto', height: '36px' }} 
            >
                <defs>
                    <mask id={`battery-mask-${index}`}>
                        <rect x="0" y="0" width="24" height="24" fill="#ffffff50" />
                        <rect x="5" y={`${24 - (clampedPercentage / 100) * 24}`} width="14" height={`${(clampedPercentage / 100) * 24}`} fill="#fff" />
                    </mask>
                </defs>
                <rect width="24" height="24" fill="#ffffff" fillOpacity="0" />
                <path
                    d="m11,20v-3h-4v3.67c0,.73.6,1.33,1.33,1.33h7.33c.74,0,1.34-.6,1.34-1.33v-3.67h-4.4l-1.6,3Z"
                    fill="#fff"
                    mask={`url(#battery-mask-${index})`}
                    fillOpacity={clampedPercentage === 0 ? 0.4 : 1}
                />
                <path
                    d="m15.67,4h-1.67v-2h-4v2h-1.67c-.73,0-1.33.6-1.33,1.33v11.67h4v-2.5h-2l4-7.5v5.5h2l-2.4,4.5h4.4V5.33c0-.73-.6-1.33-1.33-1.33Z"
                    fill="#fff"
                    mask={`url(#battery-mask-${index})`}
                    fillOpacity={clampedPercentage === 0 ? 0.4 : 1}
                />
            </svg>
            <div style={{ fontSize: '12px', color: 'white' }}>{value}</div>
        </div>
    );
};

